import React from 'react';
import '../home-style/home-style.css';


const InstagramWidget: React.FC = () => {
    return (
        <div className="instagram-widget">
            {/* Widget de Instagram */}
            <iframe
                src="https://www.instagram.com/asados_al_barril_/embed/"
                frameBorder="0"
                scrolling="yes"
                allowTransparency={true}
                title="Instagram Widget"
                style={{
                    width: '100%',
                    height: '400px', // Ajuste estándar para una mejor visualización
                    border: 'none'
                }}
            ></iframe>
        </div>
    );
};

export default InstagramWidget;